import { ref, provide, inject } from 'vue'
import { useRouter } from 'vue-router'

const navigationKey = Symbol('navigation')

export function provideSectionNavigation() {
  const router = useRouter()

  const navigateToSection = (sectionId) => {
    const isSamePage = router.currentRoute.value.path === '/'

    if (isSamePage) {
      // Already on landing page, scroll to section
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    } else {
      // Navigate to landing page with hash
      router.push({ path: '/', hash: `#${sectionId}` })
    }
  }

  provide(navigationKey, { navigateToSection })

  return { navigateToSection }
}

export function useSectionNavigation(): { navigateToSection: (sectionId: string) => void } {
  const navigation = inject(navigationKey)
  if (!navigation) {
    // Return a default implementation instead of throwing
    return {
      navigateToSection: (sectionId: string) => {
        const element = document.getElementById(sectionId)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      }
    }
  }
  return navigation as { navigateToSection: (sectionId: string) => void }
}
